// extracted by mini-css-extract-plugin
module.exports = {"list":"TableList_list__xHzTX","listItem":"TableList_listItem__XpYnN"};